import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/shaoshuai.svg'


const _withScopeId = n => (_pushScopeId("data-v-760cfd09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-box gWidth animated animate__fadeIn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "panel-title" }, [
  /*#__PURE__*/_createTextVNode("关于我"),
  /*#__PURE__*/_createElementVNode("span", { class: "emoji" }, "🎀")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introduction_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "introduce" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", { class: "cr8" }, "邵帅"),
      /*#__PURE__*/_createTextVNode("，1996年，专科，毕业于"),
      /*#__PURE__*/_createElementVNode("strong", null, "'河北软件职业技术学院'"),
      /*#__PURE__*/_createTextVNode("，专业"),
      /*#__PURE__*/_createElementVNode("strong", null, "'计算机信息管理'")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "本人性格开朗，乐观向上，有较好的团队协作能力。"),
    /*#__PURE__*/_createElementVNode("p", null, " 工作态度端正、认真负责、做事细心并有耐心。适应能力强，抗压能力强。 "),
    /*#__PURE__*/_createElementVNode("p", null, "平时关注“稀土掘金”、“简书”之类的相关资料对自己进行技术上提升。")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "panel-title" }, [
  /*#__PURE__*/_createTextVNode("工作经历"),
  /*#__PURE__*/_createElementVNode("span", { class: "emoji" }, "🎀")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "XXX发展有限公司 前端开发", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 工作描述： 1、制作网站、app简单的设计图，主要用Photoshop。 2、完成页面布局，与后端合作，完成前后端数据交互。 3、与产品商议，确定需求，从而达到友好的用户体验。 4、团队讨论具体功能的细节问题，与其他技术人员沟通并制定设计规范。 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "XXX信息科技有限公司 程序员（实习）", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 工作描述： 1、根据ui设计图，完成页面布局。 2、开发微信小程序，商议小程序具体功能以及细节问题。 3、开发网站主要用到织梦快速建站。 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "panel-title" }, [
  /*#__PURE__*/_createTextVNode("项目经验"),
  /*#__PURE__*/_createElementVNode("span", { class: "emoji" }, "🎀")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "德亿体育（deyity.com） 前端开发", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1、 负责网站整体UI设计，主要用到的工具Photoshop。 2、 前端页面开发，使用Vue+Element UI等开发页面。 3、 与后台对接接口，使用Axios请求接口，获取后台数据渲染页面。 4、 用到Echarts做球路走势图、qrcodejs2生成二维码、vue-cropper头像上传裁剪、vue3-print-nb打印等插件。 5、 配置Prettier+ESLint进行代码校验。 6、 使用路由懒加载首屏内容定制、图片懒加载、CDN等技术优化网站性能 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "球冠天下app（安卓版） 前端开发", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1、 负责整体UI设计制作，主要用到的工具Photoshop。 2、 为兼容多端用行使用flxe布局。 3、 使用uni-app组件库、API及插件。 4、 封装uni.request请求，并挂在到全局。 5、 使用uni.getProvider、uni.requestPayment等API完成用户支付功能。 6、 配置app启动页检查设备网络、版本更新、消息推送等功能。 7、 使用HBuilderX工具进行项目搭建调试以及打包apk发布。 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "panel-title" }, [
  /*#__PURE__*/_createTextVNode("联系我"),
  /*#__PURE__*/_createElementVNode("span", { class: "emoji" }, "🎀")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1136627300@qq.com", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "北京市西城区三里河", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "在职", -1))
const _hoisted_18 = { class: "self-sidebar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_cpn_synopsis = _resolveComponent("cpn-synopsis")!
  const _component_cpn_introduce = _resolveComponent("cpn-introduce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "synopsos_box" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_el_divider),
        _hoisted_4,
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, {
              timestamp: "2019/8—至今",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_timeline_item, {
              timestamp: "2018/7—2019/7",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _hoisted_9,
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, {
              timestamp: "2020/5—2021/9",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_timeline_item, {
              timestamp: "2019/10—2020/3",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _hoisted_14,
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, {
              timestamp: "邮箱",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_el_timeline_item, {
              timestamp: "所在地",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_el_timeline_item, {
              timestamp: "在职状态",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_cpn_synopsis),
      _createVNode(_component_cpn_introduce, { style: {"margin-top":"10px"} })
    ])
  ]))
}